import {
  AfterViewInit,
  OnDestroy,
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import {
  AlertService,
  PublicationService,
  AppService,
} from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

class Publications {
  id: number;
  heading: string;
  publish_date: string;
  publication_type: string;
  html_url: string;
  html_thumbnail: string;
  is_active: string;
  type: string;
  description: string;
}

@Component({
  selector: "app-publications",
  templateUrl: "./publications.component.html",
})
export class PublicationsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() allowMultiple: boolean;
  @Input() fileType: string = ".html, .htm, .pdf";
  @Input() imageType: string = ".png, .jpg, .jpeg";
  invalidDate: boolean = false;
  @Output() onSelection = new EventEmitter<FileList>();
  DisplayedText: string = "";
  DisplayedText1: string = "";
  fileList: any;
  isChecked: boolean = false;
  fileSelected: boolean = false;
  verifyValue: string = "N";
  imageList: any;
  html_url1: string = "";
  html_thumbnail1: string = "";
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };
  dtTrigger = new Subject();
  publicationsList: Publications[] = []; // Table Data list
  isSubmitted = false;
  modalReference: NgbActiveModal;
  modalTitle: string;
  showloding = true;
  lodingImage = false;

  getPublications = {
    id: "",
    heading: "",
    publish_date: "",
    publication_type: "",
    html_url: "",
    html_thumbnail: "",
    is_active: "",
    type: "",
    description: "",
  };

  closeResult: string; // Modal Close
  constructor(
    public router: Router,
    private dataService: PublicationService,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal
  ) {}

  publications = {
    id: "",
    heading: "",
    publish_date: "",
    publication_type: "",
    html_url: "",
    html_thumbnail: "",
    is_active: "",
    type: "",
    description: "",
  };

  ngOnInit() {
    window.scroll(0, 0);
    this.allPublications();
  }

  allPublications() {
    this.loadShow();
    this.dataService
      .getAllPublication()
      .pipe()
      .subscribe((data) => {
        this.publicationsList = data["publications"];
        this.rerender();
        this.loadHide();
      });
  }

  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.isChecked = input.checked;
    this.verifyValue = this.isChecked ? "Y" : "N";
  }

  validateDate(publishDate: any) {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;

    if (publishDate && publishDate.value !== "") {
      if (!datePattern.test(publishDate.value)) {
        this.invalidDate = true;
      } else {
        this.invalidDate = false;
      }
    } else {
      this.invalidDate = false;
    }
  }

  open(content) {
    this.DisplayedText1 = "";
    this.isSubmitted = false;
    if (this.getPublications.id != null) {
      this.getPublications.id = "";
    }
    this.verifyValue = "N";
    this.isChecked = false;
    this.publications.id = "";
    this.publications.heading = "";
    this.publications.publish_date = "";
    this.publications.publication_type = "";
    this.publications.html_url = "";
    this.publications.html_thumbnail = "";
    this.publications.is_active = "Y";
    this.publications.description = "";
    this.publications.type = "";
    this.DisplayedText = "";
    this.modalTitle = "Add Publication";
    this.html_thumbnail1 = "";
    this.html_url1 = "";

    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  save(val, f) {
    this.isSubmitted = true;

    if (
      this.publications.type == "Blog" &&
      (!this.publications.description ||
        this.publications.description.trim() === "")
    ) {
      return;
    }

    if (this.isFieldsInvalid(this.publications.heading)) {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (this.invalidDate) {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (
      this.publications.publish_date == undefined ||
      this.publications.publish_date == ""
    ) {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (this.publications.publication_type == "1") {
      if (
        !this.publications.html_url ||
        this.publications.html_url.trim() === ""
      ) {
        document
          .querySelector(".modal")
          .scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
    } else if (this.publications.publication_type == "2") {
      if (!this.fileSelected) {
        document
          .querySelector(".modal")
          .scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
    }

    if (f.form.valid) {
      this.loadShow();
      this.insertAction(val);
    } else {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  edit(id, content) {
    this.loadShow();
    this.DisplayedText = "";
    this.DisplayedText1 = "";
    this.dataService.getPublication(id).subscribe((data) => {
      this.getPublications = data["publications"];
      let html_urls;
      this.fileSelected = true;
      if (this.getPublications.publication_type == "1") {
        html_urls = this.getPublications.html_url;
      } else {
        html_urls = this.getPublications.html_url;
      }

      this.isChecked = data["publications"]["most_inspiring"] === "Y";
      this.verifyValue = this.isChecked ? "Y" : "N";
      this.publications = {
        id: this.getPublications.id,
        heading: this.getPublications.heading,
        html_url: this.getPublications.html_url,
        publish_date: this.getPublications.publish_date,
        publication_type: this.getPublications.publication_type,
        type: this.getPublications.type,
        description: this.getPublications.description,
        html_thumbnail: this.getPublications.html_thumbnail,
        is_active: this.getPublications.is_active,
      };

      this.loadHide();
      this.modalTitle = "Edit Publication";
      this.modalReference = this.modalService.open(content, {
        backdrop: "static",
        keyboard: false,
      });
    });
  }

  insertAction(val) {
    let formData: FormData = new FormData();
    if (this.publications.publication_type == "2") {
      if (this.fileList != undefined) {
        let file: File = this.fileList[0];
        formData.append("html_url", this.html_url1);
      } else {
        formData.append("html_url", "");
      }
    } else {
      formData.append("html_url", this.publications.html_url);
    }

    if (this.imageList != undefined) {
      let file1: File = this.imageList[0];
      formData.append("html_thumbnail", this.html_thumbnail1);
    }

    formData.append("heading", this.publications.heading);
    formData.append("publication_type", this.publications.publication_type);
    formData.append("publish_date", this.publications.publish_date);
    formData.append("is_active", this.publications.is_active);
    formData.append("most_inspiring", this.verifyValue);
    formData.append("type", this.publications.type);

    if (this.publications.type == "Blog") {
      formData.append("description", this.publications.description);
    } else {
      formData.append("description", "");
    }

    if (val.id == "") {
      this.dataService
        .save(formData)
        .pipe()
        .subscribe(
          (data) => {
            if (data["status"] == 200) {
              this.modalReference.close();
              this.allPublications();
              this.publications.html_url = "";
              this.html_thumbnail1 = "";
              this.alertService.success(
                "Publication created successfully",
                true
              );
            } else {
              this.loadHide();
            }
            this.loadHide();
          },
          (error) => {
            this.alertService.error(error);
            this.loadHide();
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
          }
        );
    } else {
      formData.append("id", val.id);
      this.dataService
        .publicationUpdate(formData)
        .pipe()
        .subscribe(
          (data) => {
            if (data["status"] == 200) {
              this.modalReference.close();
              this.allPublications();
              this.alertService.success(
                "Publication updated successfully",
                true
              );
            } else {
              this.loadHide();
            }
            this.loadHide();
          },
          (error) => {
            this.loadHide();
            this.alertService.error(error);
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
          }
        );
    }
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .publicationDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success("Publication deleted successfully", true);
            item.is_active = item.is_active === "Y" ? "N" : "Y";
            this.allPublications();
          } else {
            this.alertService.error("Publication error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    this.loadHide();
  }

  imageChange(event: any) {
    this.imageList = event.target.files;
    let hasFile = this.imageList && this.imageList.length > 0;
    if (hasFile) {
      var extension = this.imageList[0].name.substring(
        this.imageList[0].name.lastIndexOf(".")
      );
      // Only process image files.
      var validFileType = this.imageType;
      if (validFileType.toLowerCase().indexOf(extension) < 0) {
        alert(
          "please select valid file type. The supported file types are " +
            this.imageType
        );
        this.imageList = null;
        this.DisplayedText = "";
        return false;
      }

      if (this.imageList[0].size > 5000000) {
        alert(`File size is more than 5 MB`);
        this.imageList = null;
        this.DisplayedText = "";
        return false;
      }

      let multipleFile = this.imageList.length > 1;
      if (multipleFile) {
        this.DisplayedText =
          this.imageList.length + " file(s) has been selected";
      } else {
        let file: File = this.imageList[0];
        this.DisplayedText = file.name;
        const reader = new FileReader();
        reader.readAsDataURL(this.imageList[0]);
        reader.onload = () => {
          this.html_thumbnail1 = reader.result as string;
          this.publications.html_thumbnail = this.html_thumbnail1;
        };
      }
      this.onSelection.emit(this.imageList);
    }
  }

  fileChange(event: any) {
    this.fileList = event.target.files;
    const file = event.target.files[0];
    let hasFile = this.fileList && this.fileList.length > 0;

    if (file) {
      this.fileSelected = true;
    } else {
      this.fileSelected = false;
    }

    if (hasFile) {
      var extension = this.fileList[0].name.substring(
        this.fileList[0].name.lastIndexOf(".")
      );
      var validFileType = this.fileType;

      if (this.fileList[0].size > 15000000) {
        alert(`File size is more than 15 MB`);
        this.fileList = null;
        this.DisplayedText1 = "";
        return false;
      }

      let multipleFile = this.fileList.length > 1;
      if (multipleFile) {
        this.DisplayedText1 =
          this.fileList.length + " file(s) has been selected";
      } else {
        let file: File = this.fileList[0];
        this.DisplayedText1 = file.name;
        const reader = new FileReader();
        reader.readAsDataURL(this.fileList[0]);
        reader.onload = () => {
          this.html_url1 = reader.result as string;
          this.publications.html_url = this.html_url1;
        };
      }
      this.onSelection.emit(this.fileList);
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
